import React from 'react';

import { Card, Label, Button, ScrollableContainer } from '@ergeon/core-components';
import { PlusIcon } from '@ergeon/icons/hero/micro';

import { useInfiniteScroll } from '../../hooks/useInfiniteScroll';
import { NoConversationsEmptyState } from '../EmptyStates';
import ListDivider from '../ListDivider';
import LoadingState from '../LoadingState';

import { useAIAgentContext } from './AIAgentContext';
import AIAgentThreadItem from './AIAgentThreadItem';

const AIAgentThreadList = () => {
  const {
    threads,
    currentThreadId,
    isLoadingThreads,
    hasMoreThreads,
    selectThread,
    handleDeleteThread,
    startNewConversation,
    loadMoreThreads,
  } = useAIAgentContext();

  const { observerTarget } = useInfiniteScroll({
    hasMore: hasMoreThreads,
    isLoading: isLoadingThreads,
    onLoadMore: loadMoreThreads,
  });

  const renderContent = () => {
    if (isLoadingThreads && threads.length === 0) {
      return <LoadingState />;
    }

    if (!isLoadingThreads && threads.length === 0) {
      return <NoConversationsEmptyState />;
    }

    return (
      <div className="flex flex-col flex-1 px-2 overflow-hidden">
        <ScrollableContainer className="px-2" direction="col" maskSize={0}>
          <div className="flex flex-col">
            {threads.map((thread, index) => (
              <React.Fragment key={thread.id}>
                <AIAgentThreadItem
                  isSelected={thread.id === currentThreadId}
                  onDelete={handleDeleteThread}
                  onSelect={selectThread}
                  thread={thread} />
                {index < threads.length - 1 && <ListDivider />}
              </React.Fragment>
            ))}
          </div>
          {hasMoreThreads && <div className="h-0" ref={observerTarget} />}
          {isLoadingThreads && hasMoreThreads && <LoadingState />}
        </ScrollableContainer>
      </div>
    );
  };

  return (
    <Card className="flex flex-col w-full overflow-hidden shrink-0" tag="aside" zIndex="1">
      <div className="flex justify-between items-start p-4">
        <Label>Conversations</Label>
        <Button
          aria-label="Start new conversation"
          className="whitespace-nowrap"
          flavor="primary"
          onClick={startNewConversation}
          size="small"
          taste="line"
          title="Start a New Conversation">
          <PlusIcon className="size-4 shrink-0" />
          New Chat
        </Button>
      </div>
      {renderContent()}
    </Card>
  );
};

export default AIAgentThreadList;
